import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllItems = (sectionid) =>
  apiClient.get(`${REST_API_BASE_URL}/items/section/${sectionid}`);
export const getAllItemsForLevel = (sectionid) =>
  apiClient.get(`${REST_API_BASE_URL}/items/sectionlevel/${sectionid}`);

export const saveItem = (sectionid: number, item: any) =>
  apiClient.post(`${REST_API_BASE_URL}/item/${sectionid}`, item);

export const getItem = (id) => apiClient.get(`${REST_API_BASE_URL}/item/${id}`);

export const updateItem = (id: number, item: any) =>
  apiClient.put(`${REST_API_BASE_URL}/item/${id}`, item);

export const deleteItem = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/item/${id}`);

export const getAllItemsByParent = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/parent/${id}/items`);

export const getAllQuestionsByItem = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}/questions`);

export const getItemsByApp = (appId) =>
  apiClient.get(`${REST_API_BASE_URL}/app/${appId}/items`);

export const getAllDocumentsByItem = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}/documents`);

export const getAllAttachmentsByItem = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}/attachments`);

export const addItemToParent = (parentid, itemid, item) =>
  apiClient.put(`${REST_API_BASE_URL}/parent/${parentid}/item/${itemid}`, item);

export const removeItemToParent = (parentid, itemid) =>
  apiClient.delete(`${REST_API_BASE_URL}/parent/${parentid}/item/${itemid}`);

export const addQuestionToItem = (itemid, questionid) =>
  apiClient.put(`${REST_API_BASE_URL}/item/${itemid}/question/${questionid}`);

export const removeQuestionToItem = (itemid, questionid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/item/${itemid}/question/${questionid}`,
  );

export const addDocumentToItem = (itemid, documentid) =>
  apiClient.put(`${REST_API_BASE_URL}/item/${itemid}/document/${documentid}`);

export const removeDocumentToItem = (itemid, documentid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/item/${itemid}/document/${documentid}`,
  );

export const addAttachmentToItem = (itemid, attachmentid) =>
  apiClient.put(
    `${REST_API_BASE_URL}/item/${itemid}/attachment/${attachmentid}`,
  );

export const removeAttachmentToItem = (itemid, attachmentid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/item/${itemid}/attachment/${attachmentid}`,
  );

export default apiClient;
